import {BusinessPicklistRow} from './business-picklist-row';
import {Bizinquiry} from '../request/bizinquiry';
import {BusinessReport} from './business';
import {LumbermensBusiness} from '../../lumbermens/lumbermens-business';

export interface BusinessPickList {
  businessResponse: string;
}

export interface BusinessPickListResponse {
  bizinquiry: Bizinquiry;
  business?: BusinessReport;
  picklist: Picklist;
  consumersegments?: any;
  addonsResults: AddonsResults;
}

export interface Picklist {
  rows: BusinessPicklistRow[];
}

export interface AddonsResults {
  [key: string]: AddonsResult[];
}

export interface AddonsResult {
  productCode: string;
  code: string;
  message: string;
  lumbermenBusinesses?: LumbermensBusiness[];
}

export function getAddon(businessPickListResponse: BusinessPickListResponse, addon: string, addonsResultsIndex: number = 0): AddonsResult {
  return businessPickListResponse.addonsResults && businessPickListResponse.addonsResults[addon] && businessPickListResponse.addonsResults[addon][addonsResultsIndex] || null;
}

function isAddonInquiry(v: any[]): v is {addon: string; addonsResultsIndex?: number}[] {
  return v && v.length && v.length > 0 && v[0].hasOwnProperty('addon');
}
